export default __webpack_public_path__ + "static/media/solanato-tomatoes_mac-cheese.99051860.jpg";